export default {
  label: {
    title: 'Filtros globais',
    description: 'Aqui você define as regras de filtragem para todo o dashboard.',
    button: {
      cancelButton: 'Cancelar',
      confirmButton: 'Aplicar',
      clearButton: 'Limpar tudo',
      primaryButton: 'Confirmar',
    },
    listening: {
      subtitle: 'Publicações',
      session: {
        what: 'O que',
        when: 'Quando',
        where: 'Onde',
        who: 'Quem',
      },
    },
    sac: {
      subtitle: 'Métricas Proprietárias e Smart Care',
    },
    blip: {
      subtitle: 'Blip',
    },
  },
};
